import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cancel: {
    id: 'answerQuestionnaireModal.cancel',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'answerQuestionnaireModal.submit',
    defaultMessage: 'Submit',
  },
});

export default messages;
